var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"kodomo-syokudo"}},[_c('NavBar'),_c('LogoBanner'),_c('Banner'),_c('MainMessage'),_c('ActivityDetail'),_c('Footer',{scopedSlots:_vm._u([{key:"sns-share",fn:function(){return [_c('SnsShare')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }